// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  fragment transactionFragment on Transaction {
    _id
    __typename
    createdAt
    ownerId
    category
    parentModelType
    parentId
    link {
      id
      type
    }
    userFullName
    recipientId
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Fragments/transactionFragment.js